import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// cn combines clsx's conditional class joining with tailwind-merge's
// understanding of Tailwind's precedence rules so callers can safely
// override individual classes without manually de-duplicating them.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
